"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _SearchBox = _interopRequireDefault(require("../../../preact-components/search-box/SearchBox"));

var _dropdown = _interopRequireWildcard(require("../../../preact-components/design-system-components/dropdown"));

var _assets = _interopRequireDefault(require("../../../preact-components/assets"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _logger = require("@insided/shared/services/logger");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CompaniesDropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CompaniesDropdown, _Component);

  var _super = _createSuper(CompaniesDropdown);

  function CompaniesDropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CompaniesDropdown);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchWithDebounce", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      companiesList: [],
      searchValue: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchCompaniesList", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(searchText) {
        var query, res, records;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                query = searchText ? {
                  searchText: searchText
                } : {};
                _context.next = 4;
                return _axios.default.post('/analyticsV2/fetchCompaniesList', query);

              case 4:
                res = _context.sent;
                records = res.data.records;

                _this.setState({
                  companiesList: records
                });

                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                _logger.logger.error(_context.t0, {
                  component: 'CompaniesDropdown',
                  action: 'fetchCompaniesList'
                });

                _this.setState({
                  companiesList: []
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchInput", function (e) {
      var value = e.target.value;

      _this.setState({
        searchValue: value
      });

      _this.fetchWithDebounce(value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearSelectedCompany", function (e) {
      e.stopPropagation();

      _this.props.onCompanySelect();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearSearch", function (e) {
      e.stopPropagation();

      _this.setState({
        searchValue: ''
      });

      _this.fetchCompaniesList();
    });
    _this.fetchWithDebounce = (0, _debounce.default)(_this.fetchCompaniesList, 150);
    return _this;
  }

  (0, _createClass2.default)(CompaniesDropdown, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchCompaniesList();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          selectedCompany = _this$props.selectedCompany,
          onCompanySelect = _this$props.onCompanySelect,
          isSalesforceIntegrationEnabled = _this$props.isSalesforceIntegrationEnabled;
      var _this$state = this.state,
          searchValue = _this$state.searchValue,
          companiesList = _this$state.companiesList;
      return (0, _preact.h)(_dropdown.default, {
        size: "M",
        align: "left",
        popupName: "company-selection",
        disabled: !isSalesforceIntegrationEnabled,
        trigger: function trigger(isOpen) {
          return (0, _preact.h)(_Button.default, {
            key: "companyDropdown",
            className: "company-dropdown-button".concat(isOpen ? ' company-dropdown-button-open' : '').concat(isSalesforceIntegrationEnabled ? '' : ' company-dropdown-button-disabled'),
            size: "medium",
            "data-element-name": "Company filter button",
            "data-track-type": "click",
            title: (0, _preact.h)("div", {
              className: "company-dropdown-trigger"
            }, (0, _preact.h)("span", {
              className: "company-dropdown-fix-text"
            }, "Company"), selectedCompany ? (0, _preact.h)("span", {
              className: "company-dropdown-selected-wrapper"
            }, (0, _preact.h)("span", {
              className: "company-dropdown-selected"
            }, selectedCompany.name), (0, _preact.h)("button", {
              className: "company-dropdown-clear-button",
              onClick: _this2.onClearSelectedCompany,
              "data-element-name": "Company filter clear button",
              "data-track-type": "click"
            }, (0, _preact.h)(_assets.default, {
              customClass: "company-dropdown-icon-clear",
              icon: "close",
              height: 16,
              width: 16
            }))) : (0, _preact.h)("span", {
              className: "company-dropdown-selected"
            }, "All"))
          });
        },
        closeOnDropdownClick: true
      }, (0, _preact.h)("div", {
        className: "company-dropdown-searchBox"
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: "Search for company",
        value: searchValue,
        onSubmit: function onSubmit() {},
        onInput: this.onSearchInput,
        onClear: this.onClearSearch
      })), companiesList.map(function (item) {
        return (0, _preact.h)(_dropdown.DropdownItem, {
          key: item.name,
          onClick: function onClick() {
            onCompanySelect(item.id, item.name);
          },
          "data-element-name": "Company filter option",
          "data-track-type": "click"
        }, (0, _preact.h)("div", null, (0, _preact.h)("div", {
          className: "email-variable"
        }, item.name)));
      }));
    }
  }]);
  return CompaniesDropdown;
}(_preact.Component);

var _default = CompaniesDropdown;
exports.default = _default;